import { useState, useCallback } from 'react';
import { IJobFilterUserOption, IOptionType } from '../Jobs/types';
import Api from '../Jobs/API';

interface FilterUserOptionsResponse {
  res: {
    [key: string]: IJobFilterUserOption[];
  };
  resHead: {
    [key: string]: string;
  };
}

export const useJobFilterUserOptions = (type: string) => {
  const [data, setData] = useState<IOptionType[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = useCallback(async (archived: boolean) => {
    setIsLoading(true);
    try {
      let page = 1;
      let totalPages = 9999;
      let results: IJobFilterUserOption[] = [];

      while (page <= totalPages) {
        const response = (await Api.getJobFilterOptionsPaginated(type, {
          'filter[archived]': archived,
          page
        })) as FilterUserOptionsResponse;

        const currentPageData = response.res[type] || [];
        results = [...results, ...currentPageData];

        if (page === 1) {
          const transformedResults = results.map((user) => ({
            id: user.id,
            name: `${user.firstname} ${user.lastname}`.trim()
          }));
          setData(transformedResults);
        }

        totalPages = parseInt(response.resHead?.['x-total-pages'] || '1');
        page += 1;
      }

      if (page > 1) {
        const transformedResults = results.map((user) => ({
          id: user.id,
          name: `${user.firstname} ${user.lastname}`.trim()
        }));
        setData(transformedResults);
      }
    } catch (error) {
      console.error('Error fetching assigned users:', error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { data, isLoading, fetchData };
};
